<!-- <div [class.ambulance-card]="item.serviceType_code == 'ambulance'" class="status-div-container">
<div class="col-12 p-0">
  <div class="d-flex status-container">
    <ng-container *ngFor="let field of statusResource">
      <div *ngIf="field.valid" class="flex-fill w-25 text-center">
        <div class="field.class_name">
          <label class="status-label" for="payment">{{field.heading}}</label>
        </div>
        <div class="status-icon">
          <img *ngIf="field.status !== true" src="./assets/images/icon-stage-empty.png">
          <img *ngIf="field.status === true" src="./assets/images/icon-stage.png">
        </div>
      </div>
    </ng-container>
  </div>
</div>
</div> -->
<div [class.ambulance-card]="item.serviceType_code == 'ambulance'" class="_wf-card-level3">
  <div class="_wf-card__stage-contain">
    <!-- <div class="_wf-card__stage">
    <div class="_wf-card__stage-title">
      <h3 class="_heading-3 center-align">Payment<br>successful</h3>
    </div>
    <div class="_wf-card__stage-icon"><img src="assets/images/stage-check.svg" loading="lazy" alt=""></div>
  </div> -->
  @for (field of statusResource; track field) {
    @if (field.valid) {
      <div class="_wf-card__stage">
        <!-- <div class="field.class_name"> -->
        <div class="_wf-card__stage-title">
          <h3 class="_heading-3 center-align">{{field.heading | translate | async}}</h3>
        </div>
        <div class="_wf-card__stage-icon">
          @if (field.status !== true) {
            <img src="./assets/images/stage-uncheck.svg" >
          }
          @if (field.status === true && field.icon) {
            <img src="./assets/images/{{field.icon}}.svg">
          }
          @if (field.status === true && !field.icon) {
            <img src="./assets/images/stage-check.svg" style="width: 28px; height: 14px; object-fit: contain;">
          }
        </div>
      </div>
    }
  }
</div>
</div>